module.exports = __webpack_public_path__ + "img/Butterfly_00332.524a41e8.png";